import { createPopper } from '@popperjs/core';
import { Component, h, Prop, Element, Watch } from '@stencil/core';
import { PopoverPlacement } from './interfaces/popoverInterfaces';

@Component({
  tag: 'udp-pop-over',
  styleUrl: 'udp-pop-over.css',
  shadow: true,
})
export class UdpPopOver {
  @Prop({ mutable: true }) isOpen: boolean = false;
  @Prop() anchorElement: HTMLElement;
  @Prop() popoverWidth: string;
  @Prop() popoverMaxHeight: string;
  @Prop() handleOnClose: (event: Event) => void;
  @Prop() popoverPlacement: PopoverPlacement = 'bottom-end';
  @Element() el: HTMLElement;
  popoverInstance: any;

  componentWillLoad() {
    if (this.isOpen) {
      document.addEventListener('click', this.handleClose);
    } else {
      document.removeEventListener('click', this.handleClose);
    }
  }

  @Watch('isOpen')
  watchHandler(newValue: boolean) {
    if (newValue) {
      document.addEventListener('click', this.handleClose);
    } else {
      document.removeEventListener('click', this.handleClose);
    }
  }

  handleClose = (event?: Event) => {
    if (event && this.el?.shadowRoot?.contains(event.target as Node)) {
      return; // Clicked inside, do nothing
    }
    document.removeEventListener('click', this.handleClose);
    if (this.handleOnClose) {
      this.handleOnClose(event);
    }
    this.isOpen = false;
  };

  createPopperInstance() {
    if (this.anchorElement) {
      this.popoverInstance = createPopper(this.anchorElement, this.el.shadowRoot.querySelector('.popover'), {
        placement: this.popoverPlacement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 5],
            },
          },
        ],
      });
    }
  }

  componentDidLoad() {
    if (this.popoverInstance) {
      this.popoverInstance?.update();
    } else {
      this.createPopperInstance();
    }
  }

  disconnectedCallback() {
    if (this.popoverInstance) {
      this.popoverInstance.destroy();
    }
  }

  render() {
    const style = {
      display: this.isOpen ? 'block' : 'none',
      position: 'absolute',
      width: this.popoverWidth,
      maxHeight: this.popoverMaxHeight,
    };

    return (
      <div class="popover" style={style}>
        <slot></slot>
      </div>
    );
  }
}
